import { render, staticRenderFns } from "./PhotoManagement.vue?vue&type=template&id=23f56b93&scoped=true"
import script from "./PhotoManagement.vue?vue&type=script&lang=js"
export * from "./PhotoManagement.vue?vue&type=script&lang=js"
import style0 from "./PhotoManagement.vue?vue&type=style&index=0&id=23f56b93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f56b93",
  null
  
)

export default component.exports